<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb  />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد کد تخفیف
        </b-button>
      </b-col>
    </b-row>
    <div v-if="getOffers">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>


      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>id</b-th>
            <b-th>عنوان</b-th>
            <b-th>فروشنده</b-th>
            <b-th>تعداد کد تخفیف</b-th>
            <b-th>عنوان خدمات</b-th>
            <b-th>تاریخ ایجاد</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="item in getOffers" :key="item.id" v-if="item.serviceable_type===serviceable_type">
            <b-td>{{ item.id }}</b-td>
            <b-td>{{ item.title }}</b-td>
            <b-td>
              {{item.seller.full_name}}
              <br/>
              <b-badge variant="dark"  style="direction: ltr">
                {{item.seller.mobile}}
              </b-badge>
            </b-td>
            <b-td>{{item.count}} عدد</b-td>
            <b-td>
              {{item.service_name}}
              <br/>
              <b-badge variant="info">
                {{ item.service_full_name }}
              </b-badge>
            </b-td>


            <b-td>
              {{
                new Date(item.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                        item.status != 'active' ? 'text-danger' : 'text-success'
                      "
              >
                {{ item.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
                <router-link
                    :to="{ name: 'discountCarShow', params: { id: item.id} }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconCalendar2Event />
                </router-link>
                <b-button
                    @click="showConfirmModal(item)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
                <b-button
                    @click="showFormModal(item)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="800px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش کد تخفیف" : "ایجاد کد تخفیف" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="row">
        <b-form-group class="col-md-12">
          <label for="title" class="text-capitalize"
          > عنوان کد تخفیف <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="discountInput.title"
              id="title"
              key="title1"
              placeholder="عنوان کد تخفیف"
          />
        </b-form-group>
        <b-form-group class="col-md-12">
          <label for="admin_user" class="text-capitalize"> انتخاب فروشنده (اگه در لیست نیست بعنوان کاربر آن را ثبت نمایید) :</label>
          <v-select
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="discountInput.seller_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.full_name"
              :reduce="(user) => user.id"
              :options="users"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ full_name, mobile }">
              {{ full_name }}
              <br />
              <cite>{{ mobile }}</cite>
            </template>
          </v-select>
        </b-form-group>

        <b-form-group class="col-md-12">
          <label for="admin_user" class="text-capitalize"> انتخاب تجربه (کد تخفیف فقط برای این  خدمات قابل استفاده است) :</label>
          <v-select
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="discountInput.serviceable_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.name"
              :reduce="(car) => car.id"
              :options="cars"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ name,id }" style="direction: ltr">
              <cite>{{name}}</cite>

            </template>
          </v-select>
        </b-form-group>


        <b-form-group class="col-md-12">
          <label for="salt" class="text-capitalize"
          > عبارت قبل از کد تخفیف (حتما En باشد مثل : sam) <span class="text-danger">*</span></label
          >
          <b-form-input
              style="direction: ltr"
              lazy
              :disabled="editMode"
              v-model="discountInput.salt"
              id="salt"
              key="salt"
              placeholder="عبارت قبل از کد تخفیف"
          />
        </b-form-group>

        <b-form-group class="col-md-12">
          <label for="salt" class="text-capitalize"
          > تعداد کد تخفیف تولید شده (مثلا 85 ) <span class="text-danger">*</span></label
          >
          <b-form-input
              style="direction: ltr"
              lazy
              :disabled="editMode"

              type="number"
              v-model="discountInput.count"
              id="count"
              key="count"
              placeholder="تعداد  کد تخفیف "
          />

        </b-form-group>


        <b-col md="12" class="mt-2"></b-col>
        <b-col cols="6" md="6"> تخفیف به تعداد نفرات </b-col>
        <b-col cols="6" md="6" class="d-flex justify-content-end">
          <b-form-group label-for="discount" class="col-md-6">
            <!-- @change="value2 = $events" -->
            <b-form-spinbutton
                name="discount"
                id="sb-input"
                v-model="discounts"
                size="sm"
                min="0"
                max="10"
                @input="removeDiscountBtnIsClicked = false,clickOnDiscountSpinBtn=true"
            ></b-form-spinbutton>
          </b-form-group>
        </b-col>

        <b-col
            md="12"
            v-for="(item, index) in discountInput.rules"
            :key="'off_' + index"
        >
          <b-row>
            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">از : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.min" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تا : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.max" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تخفیف : </label>
              <b-form-input v-model.number="item.percent" type="number" />
            </b-form-group>
            <b-form-group class="mt-1 col-4 col-sm-2">
              <label for="name" class="text-capitalize">به صورت : </label>
              <b-form-input disabled type="text" value="درصدی" />
            </b-form-group>
            <b-button
                @click="removeDiscount(index)"
                variant="flat-danger"
                class="font-weight-bolder col-1 col-sm-1"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
          </b-row>
        </b-col>


        <b-col md="12" class="mt-2"> </b-col>
        <b-col md="12" class="mt-2"></b-col>


        <b-col md="12">
          <b-form-textarea
              lazy
              class="col-md-12"
              v-model="discountInput.desc"
              id="title"
              key="title1"
              placeholder="توضیحات در مورد تیکت"
              rows="3"
          >

          </b-form-textarea>
        </b-col>



        <!--        <b-form-group class="col-md-12">
                  <label for="imageIcon" class="text-capitalize">
                    آپلود تصویر :
                  </label>
                  <FilePicker
                      @inputFile="inputIconImageFile"
                      :url="iconImageurl"
                      ref="iconImageFilePicker"
                  ></FilePicker>
                  <ErrorMessage
                      errorType="image"
                      :errorMessages="errorMessage"
                  ></ErrorMessage>
                </b-form-group>-->


        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
              v-model="discountInput.status"
              :aria-describedby="ariaDescribedby"
              value="active"
              @input="removeErrors('status')"
          >فعال</b-form-checkbox
          >
          <b-form-checkbox
              v-model="discountInput.status"
              :aria-describedby="ariaDescribedby"
              value="inactive"
              @input="removeErrors('status')"
          >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
              errorType="status"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BTime,
  BInputGroup, BBadge, BIconCalendar2Event,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    BIconCalendar2Event,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BTime,
    datePicker: VuePersianDatetimePicker,
    BInputGroup,
  },
  data() {
    return {

      iconImageurl: "",
      errorMessage: {},
      perPage: 10,
      page: 1,
      paginationData: null,

      users: [],
      cars: [],

      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",


      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,

      serviceable_type:"App\\Models\\Car",

/*      serviceable_type: {
        "App\\Models\\Residence": "اقامتگاه",
        "App\\Models\\Tour": "تور",
        "App\\Models\\Car": "ترانسفر",
        "App\\Models\\Experience": "تفریح",
      },*/

      discountInput: {
        id: "",
        title: "",
        seller_id: "",
        serviceable_table: "car",
        serviceable_id: "",
        salt: "",
        count:"",
        rules:  [],
        desc: "",
        image : null,
        status: "",

      },
      discountOffs:[],

      getOffers:null,

      editMode: false,
      formModal: false,
      submitLoading: false,
      discounts: 0,
      removeDiscountBtnIsClicked: false,
      clickOnDiscountSpinBtn:false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getUsers();
    this.getExperiences();
    this.getDiscount();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getTickets();
    },
    perPage(value) {
      this.page = 1;
      this.getTickets();
    },
    page(value) {
      this.getTickets();
    },
    discounts(newVal, oldVal) {
      if (this.removeDiscountBtnIsClicked|| !this.clickOnDiscountSpinBtn) {
        this.clickOnDiscountSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.discountInput.rules = [];
      } else if (newVal < oldVal) {
        this.discountInput.rules.splice(-1);
      } else if (newVal > oldVal) {
        this.discountInput.rules.push({ min: "", max: "", percent: 0 });
      }
    },


  },
  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },

    inputIconImageFile(file) {
      this.removeErrors("image");
      this.discountInput.image = file;
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getTickets();
    },


    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_all_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getExperiences(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };
      const requestData = {
        method: "get",
        url: "/site/cars/sitemap",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.cars = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },


    async getDiscount() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };

      const requestData = {
        method: "get",
        url: "/admin/discounts",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.getOffers = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    showConfirmModal(discountOff) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف کد تخفیف مطمئن هستید ؟  : ${discountOff.title}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.discountOffs = await this.discountOffs.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == discountOff.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== discountOff.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/discounts/${discountOff.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `کد تخفیف: ${discountOff.title}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.discountOffs.splice(residenceIndex, 0, discountOff);
                  });
            }
          });
    },


    showFormModal(discountOff) {
      // this.clickOnDiscountSpinBtn=false
      // console.log(discountOff.id)
      if (discountOff) {
        this.discountInput = {
          id: discountOff.id,
          title: discountOff.title,
          seller_id: discountOff.seller_id,
          serviceable_id: discountOff.serviceable_id,
          serviceable_table:  "car",
          salt: discountOff.salt,
          count:discountOff.count,
          desc:discountOff.desc,
          rules: discountOff.rules,
          status: discountOff.status,
        };
        this.editMode = true;
      } else {
        this.adminInput = {
          title: "",
          seller_id: "",
          serviceable_id:  "",
          serviceable_table: "car",
          salt: "",
          count: "",
          desc: "",
          image: "",
          status: "",
          rules: [],
        };
        this.editMode = false;
      }
      this.formModal = true;
    },

    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.discountInput.title) {
        errorMessage = "لطفا نام کد تخفیف  را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/discounts/${this.discountInput.id}`
            : `/admin/discounts`,
        data: { ...this.discountInput },
      };


      this.$http(requestData)
          .then((response) => {
            let message = " کد تخفیف با موفقیت اضافه شد";
            if (this.editMode) message = " کد تخفیف با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });

            this.submitLoading = false;
            this.formModal = false;
            location.reload();
            this.getDiscount();
          })
          .catch((err) => {
            let message = "خطا در ایجاد  کد تخفیف";
            if (this.editMode) message = "خطا در ویرایش  کد تخفیف";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },

    getExperience() {
      const requestData = {
        method: "get",
        url: `/admin/cars/${this.$route.params.id}`,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;

            this.cars = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    removeDiscount(index) {
      this.removeDiscountBtnIsClicked = true;
      this.discountInput.rules.splice(index, 1);
      this.discounts = this.discounts - 1;
    },
    removeService(index) {
      this.removeServicesBtnIsClicked = true;
      this.discountInput.special_services.splice(index, 1);
      this.services = this.services - 1;
    },


  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>